/**
 * `usePlayer` hook accessor for the global player context.
 *
 * Throws when invoked outside `<PlayerProvider>` — matches the `useAuth()` /
 * `useResponsive()` pattern in the admin SPA so misuse fails loudly during
 * development instead of silently returning `null`.
 */

import { useContext } from 'react';
import { PlayerContext, type PlayerContextValue } from './PlayerProvider';

export function usePlayer(): PlayerContextValue {
  const ctx = useContext(PlayerContext);
  if (!ctx) {
    throw new Error('usePlayer must be used inside <PlayerProvider>');
  }
  return ctx;
}
